import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-vmou';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import styles from './batchtable.module.css';
import { useHistory } from "react-router-dom";

const Batchtable = (props) => {
    const statuses = [
        "Pending",
        "Submitted",
        "Billed",
        "All"
    ]
    const exams = [
        "DEC25",
        "JUNE25",
        "DEC24"
    ]
    const [selectedExam, setSelectedExam] = useState(exams[0]);
    const [batches, setBatches] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory()

    useEffect(() => {
        let authOptions = {
            method: 'PUT',
            url: '/batch/Examiner/', 
            data: {'examinerid':props.userid,'exam':selectedExam, 'sts': 'All'},
                headers : {
                'x-auth-token' : localStorage.getItem('token')
            }
        };
        axios(authOptions)
        .then(response => {
            setBatches(response.data.map(e => {
                const abs = e.marks.filter(x => (x.status.trim().toUpperCase()==='AB')).length;
                const chk = e.marks.filter(x => (x.status.trim().toUpperCase()==='ZE')).length + e.marks.filter(x => (x.award > 0)).length;
                return ({...e, 'checked':chk,'absentee':abs,'invalidnos':e.invalid.length})
            }))
        })
        .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
            setBatches([]);
        });
    },[props.userid, selectedExam]); 


    const examSearch = (event) => {
        event.preventDefault();  
       let authOptions = {
        method: 'PUT',
        url: '/batch/Examiner/', 
        data: {'examinerid':props.userid,'exam':selectedExam, 'sts': selectedStatus},
        headers : {
            'x-auth-token' : localStorage.getItem('token')
        }
      };
      axios(authOptions)
      .then(response => {
        setBatches(response.data.map(e => {
            const abs = e.marks.filter(x => (x.status.trim().toUpperCase()==='AB')).length;
            const chk = e.marks.filter(x => (x.status.trim().toUpperCase()==='ZE')).length + e.marks.filter(x => (x.award > 0)).length;
            return ({...e, 'checked':chk,'absentee':abs,'invalidnos':e.invalid.length})
        }))
  })
      .catch(error => {
        toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
      });
    }
    
    const awlPrint = (batch) => {
        history.push({
            pathname: '/AwlPrint',
            state: {batch:batch}
        });
    }
    const sendBatch = (batch) => {
        if (batch.status === 'submitted' || batch.status === 'posted' || batch.status === 'billed') {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: "Cannot Edit Submitted Batch"});
            return;
        }
        if (batch.attempts>=100) {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: "Total Attempts Limit Over"});
            return;
        }
        history.push({
            pathname: '/Marksentry',
            state: {batch:batch}
          });
    }
    const invalidCopies = (batch) => {
        if (batch.status === 'submitted' || batch.status === 'posted' || batch.status === 'billed') {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: "Cannot Edit Submitted Batch"});
            return;
        }
        if (batch.attempts>=40) {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: "Total Attempts Limit Over"});
            return;
        }
        history.push({
            pathname: '/InvalidCopies',
            state: {batch:batch}
          });
    }
    const extraCopies = (batch) => {
        if (batch.status === 'submitted' || batch.status === 'posted' || batch.status === 'billed') {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: "Cannot Edit Submitted Batch"});
            return;
        }
        if (batch.attempts>=40) {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: "Total Attempts Limit Over"});
            return;
        }
        history.push({
            pathname: '/ExtraCopies',
            state: {batch:batch}
          });
    }


    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" tooltip="Marks Entry" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => sendBatch(rowData)} />
                <Button icon="pi pi-plus" tooltip="Add Invalid Copies" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button-warning p-mr-2" onClick={() => invalidCopies(rowData)} />
                <Button icon="pi pi-copy" tooltip="Other Subject Copies Found" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button p-mr-2" onClick={() => extraCopies(rowData)} />
                <Button icon="pi pi-print" tooltip="Print Award List" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button p-mr-2" onClick={() => awlPrint(rowData)} />
           </React.Fragment>
        );
    }

    const header = (
        <div className={styles.tableheader}>
            <h4 className="mx-0 my-1">Manage Batches</h4>
            <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return (dt)?day+"-"+month+"-"+cdt.getFullYear():'' ;
      };
    
    
    const dateBodyTemplate = (rowData) => formatDate(rowData.dtsubmitted);
    const dateBodyTemplate1 = (rowData) => formatDate(rowData.dtsend);
    const statusBodyTemplate = (rowData) => {
        if (rowData.status === 'created')
            return ('Pending');
        else
            if (rowData.status === 'submitted' || rowData.status === 'posted')
                return ('Submitted');
            else
                if (rowData.status === 'billed' )
                    return ('Billed');
    };

//            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} selection={selectedBatches} onSelectionChange={(e) => setSelectedBatches(e.value)}
    return (
    <div className={styles.datatablecruddemo}>
        <Toast ref={toast} />
        <div className={styles.Sformpr}>
            <div className=" ">
                <label htmlFor="centre" className="">Select Exam</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
            </div>
            <div className=" ">
                <label htmlFor="centre" className="ml-4">Select Batch Status</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedStatus} options={statuses} onChange={(e) => setSelectedStatus(e.value)}  placeholder="Select Status" />
            </div>
            <Button icon="pi pi-search" className="ml-2 p-button-text p-button-success" onClick={examSearch}/>
        </div>
        <div className={styles.card}>
            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} 
                dataKey="ccode" sortField="ccode" sortOrder={1} paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} batches"
                globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                <Column field="ccode" header="Course/Paper" sortable style={{textAlign:'center',   width: '12%', padding:'0 1px 0 1px' }}></Column>
                <Column field="batchcode" header="Batch/Examiner No" sortable style={{textAlign:'center',   width: '15%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="dtsend" header="Date Recd" body={dateBodyTemplate1} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="dtsubmitted" header="Date Submit" body={dateBodyTemplate} sortable style={{textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="totalcopies" header="Total" style={{textAlign:'center',   width: '6%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="checked" header="Checked" style={{textAlign:'center',   width: '6%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="absentee" header="Absentee"  style={{ textAlign:'center',  width: '6%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="invalidnos" header="Invalid"  style={{textAlign:'center', width: '5%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="status" header="Status" body={statusBodyTemplate} sortable style={{textAlign:'center', width: '8%' , padding:'0 1px 0 1px'}}></Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ textAlign:'center', width: '15%' , padding:'0 1px 0 1px'}}></Column>
            </DataTable>
        </div>

    </div>
    );
}
const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
}
  
export default connect(mapStateToProps)(Batchtable);